import dynamic from 'next/dynamic'
import React from 'react'

import { getUserRole } from 'modules/community/functions'
import type { TCommunity } from 'modules/community/types'
import { useUser } from 'modules/user/hooks/useUser'

const CommunityAdminActionsPopover = dynamic(() =>
  import('./CommunityAdminActionsPopover').then((result) => result.CommunityAdminActionsPopover),
)

export type TCommunityPageContentProps = {
  community: TCommunity
}

/**
 * ### CommunityPageMobileContent ###
 */
export const CommunityPageMobileContent: TFCC<TCommunityPageContentProps> = ({ children, community }) => {
  const roles = getUserRole(community)
  const me = useUser()

  return (
    <>
      {me.isLogged && (roles.hasRole || me.admin) && <CommunityAdminActionsPopover community={community} />}
      {children}
    </>
  )
}
